import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { AppState } from '~src/app/state/AppState';
import { MapStateToProps } from '~src/app/utils/ConnectUtils';
import { selectCatalogingOnSiteEnabled } from '~src/catalog/selectors/CatalogSelectors';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { LensSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';
import { FeatureFlags } from '~src/ts/FeatureFlags';

import { RouterError } from '../app/spaces/RouterHelpers/RouterError';
import { LensSpaceProvider, LensSpaceProviderProps } from './LensSpaceProvider';

export interface SpaceRouteParams {
  readonly id: string;
}
export interface LensRouteComponentProps extends RouteComponentProps<SpaceRouteParams> {}

export interface LensSpaceRouterOwnProps {
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}

export interface LensSpaceRouterStateProps {
  readonly catalogingOnSiteEnabled: boolean;
}

export interface LensSpaceRouterProps extends LensSpaceRouterOwnProps, LensSpaceRouterStateProps {}

export class LensSpaceRouterComponent extends React.Component<LensSpaceRouterProps> {
  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.lensPath(':id')} render={this.provider('askData')} />
        <Route exact path={this.props.urls.lensUsageAnalyticsPath(':id')} render={this.provider('usageAnalytics')}/>
        {this.getLineageRoute()}
        <Route render={this.error} />
      </Switch>
    );
  }

  private getLineageRoute = () => {
    if (FeatureFlags.askDataLensesInCatalogEnabled && this.props.catalogingOnSiteEnabled) {
      return <Route exact path={this.props.urls.lensLineagePath(':id')} render={this.provider('lineage')} />;
    }
    return <Route path={this.props.urls.lensLineagePath(':id')} render={({ match }) => (
      <Redirect to={this.props.urls.lensPath(match.params.id)} />
    )} />;
  }

  private provider = (subspaceName: LensSubspaceName): (props: LensRouteComponentProps) => JSX.Element => {
    return (props: LensRouteComponentProps): JSX.Element => {
      const lensSpaceProviderProps: LensSpaceProviderProps = {
        siteName: this.props.siteName,
        subspaceName,
        lensId: props.match.params.id,
        routeLocationSearch: props.location.search,
        routeLocationPath: props.location.pathname,
        urls: this.props.urls,
      };

      return <LensSpaceProvider {...lensSpaceProviderProps} />;
    };
  }

  private error = (): JSX.Element => {
    return <RouterError errorType={'default'} urls={this.props.urls}/>;
  }
}

const mapStateToProps: MapStateToProps<LensSpaceRouterStateProps> = (state: AppState) => ({
  catalogingOnSiteEnabled: selectCatalogingOnSiteEnabled(state),
});

export const LensSpaceRouter = connect(mapStateToProps)(LensSpaceRouterComponent);
